/* @ngInject */
export default function ($scope, LayoutService, Notices, toastr, $state, $stateParams, AuthService) {
	AuthService.redirectIfUnauthorized('notice-create', 'splash.home');

	$scope.noticeId = $stateParams.noticeId;

	$scope.loading = true;

	$scope.refresh = () => {
		$scope.loading = true;

		Notices.one($scope.noticeId)
		       .get()
		       .then((notice) => {
			       $scope.notice = notice;

			       $scope.updateLayout('Notice');

			       $scope.loading = false;
		       })
		       .catch((error) => {
			       toastr.clear();
			       toastr.error('There was an error while loading this notice, please try again.', 'Error');

			       $state.go('staff.notices.root');
		       });
	};

	$scope.save = () => {
		const notice = {
			body:        $scope.notice.body,
			timeVisible: $scope.notice.timeVisible,
			timeHidden:  $scope.notice.timeHidden,
		};

		Notices.one($scope.noticeId)
		       .customPUT(notice)
		       .then((returnedNotice) => {
			       toastr.clear();
			       toastr.success('The notice was successfully updated.', 'Notice Updated');

			       $state.go('staff.notices.root');
		       })
		       .catch((error) => {
			       toastr.clear();
			       toastr.error('There was an error while updating the notice, please try again.', 'Error');
		       });
	};

	$scope.updateLayout = (noticeName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			noticeName,
			'Notices',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.notices.root',
				             displayName: 'Notices',
			             },
			             {
				             route:       `staff.notices.edit({ noticeId: "${$scope.noticeId}" })`,
				             displayName: noticeName,
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-check"></i> Save</button>');

		LayoutService.getPageHeader()
		             .onClicked($scope.save);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/notices/edit/controller.js